/** @format */

import React, { useEffect, useState } from 'react';
import '../../css/cards/Membership.css';

import { AiFillQuestionCircle } from 'react-icons/ai';
import { useDispatch } from 'react-redux';

import { openTrainingMore } from '../../features/training';
import { getRemainingTimeUntilMsTimestamp } from '../../utils/countdown';

const Membership = ({
  image,
  icon,
  title,
  price,
  price_before,
  urls,
  items,
  endDiscount: countdownTimestampMs,
}) => {
  const defaultRemainingTime = {
    seconds: '00',
    minutes: '00',
    hours: '00',
    days: '00',
  };

  const [remainingTime, setRemainingTime] = useState(
    defaultRemainingTime
  );

  const dispatch = useDispatch();

  useEffect(() => {
    const intervalId = setInterval(() => {
      updateRemainingTime(countdownTimestampMs);
    }, 1000);
    return () => clearInterval(intervalId);
  }, [countdownTimestampMs]);

  function updateRemainingTime(countdown) {
    setRemainingTime(getRemainingTimeUntilMsTimestamp(countdown));
  }

  return (
    <div className='Membership'>
      <div className='membership-header'>
        <img src={image} alt='Header Membership' />
      </div>
      <div className='membership-body'>
        <div className='membership-info'>
          <figure className='membership-icon'>
            <img src={icon} alt='Membership Icon' />
          </figure>
          <div className='membership-name'>
            <h4>{title}</h4>
            <h5>
              ${price} USD
              <sup>${price_before}USD</sup>
            </h5>
          </div>
        </div>
        <div className='membership-countdown'>
          <h5 className='membership-countdown-title'>
            Esta oferta termina en
          </h5>
          <div className='membership-countdown-counter'>
            <div className='membership-countdown-counter-item'>
              <span>Día(s)</span>
              <p>{remainingTime.days}</p>
            </div>
            <div className='membership-countdown-counter-item'>
              <span>Hora(s)</span>
              <p>{remainingTime.hours}</p>
            </div>
            <div className='membership-countdown-counter-item'>
              <span>Minuto(s)</span>
              <p>{remainingTime.minutes}</p>
            </div>
            <div className='membership-countdown-counter-item'>
              <span>Segundo(s)</span>
              <p>{remainingTime.seconds}</p>
            </div>
          </div>
        </div>

        <ul className='membership-card-items'>
          {items.map((e, i) => (
            <li key={i}>
              {e.item}
              {e.more ? (
                <AiFillQuestionCircle
                  className='question-icon'
                  onClick={() => {
                    dispatch(
                      openTrainingMore({
                        modal: true,
                        title: e.item,
                        more: e.more,
                      })
                    );
                  }}
                />
              ) : null}
            </li>
          ))}
        </ul>
        <div className='membership-button'>
          <a
            href={urls[0].url}
            target={'_blank'}
            rel='noreferrer'
            className='paypal'>
            {urls[0].name}
          </a>
          <a
            href={urls[1].url}
            target={'_blank'}
            rel='noreferrer'
            className='card'>
            {urls[1].name}
          </a>
        </div>
      </div>
    </div>
  );
};

export default Membership;
